export class AisAgreementResponseDto {
  id: number;
  businessEntityId: number;
  providerId: number;
  institutionId: number;
  code: string;
  maxHistoricalDays: number;
  accessValidForDays: number;
  ipAddress: string;
  userAgent: string;
  acceptedDate?: Date;
  accessDisabledDate?: Date;
}
